module.exports = __webpack_public_path__ + "img/authentication.85687776.svg";